// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2EqsZ","addWidgetButton":"Header_addWidgetButton__vdSP9","dashboardTabs":"Header_dashboardTabs__1EjJr","active":"Header_active__1i2RW"};